import React, { useEffect, useState } from "react";
import { Accordion, Card, Row } from "react-bootstrap";
import renderHtml from "react-render-html";
import { FiPlus } from "react-icons/fi";

const slugify = text =>
  text
    ? text
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-")
    : "";

const ExpandableBox = ({
  data,
  initialActiveId,
  onActiveChange,
}) => {
  const [activeItem, setActiveItem] = useState(initialActiveId || null);

  useEffect(() => {
    setActiveItem(initialActiveId || null);
  }, [initialActiveId, data]);

  useEffect(() => {
    if (!activeItem || typeof window === "undefined") return;
    const scrollToActive = () => {
      const el = document.getElementById(activeItem);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };
    scrollToActive();
    const timer = setTimeout(scrollToActive, 400);
    return () => clearTimeout(timer);
  }, [activeItem]);

  const handleToggle = key => {
    const nextItem = activeItem === key ? null : key;
    setActiveItem(nextItem);
    if (onActiveChange) {
      onActiveChange(nextItem);
    }
  };

  return (
    <Accordion activeKey={activeItem} style={{ padding: "10px 0" }}>
      {data
        ? data.map(collapse => {
          const questionSlug = collapse.slug || slugify(collapse.title);
          return (
            <Row
              style={{ padding: "0", scrollMarginTop: "80px" }}
              key={questionSlug || collapse.title}
              id={questionSlug || collapse.title}>
              <div className="faq-q-container">
                <Accordion.Toggle
                  as={Row}
                  variant="link"
                  eventKey={questionSlug}
                  onClick={() => handleToggle(questionSlug)}>
                  <div className="faq-q-content">
                    {collapse.title}
                    <FiPlus
                      className="faq-q-icon"
                      style={{
                        transition: "transform 0.3s ease",
                        transform:
                          activeItem === questionSlug
                            ? "rotate(-45deg)"
                            : "rotate(0deg)",
                      }}
                    />
                  </div>
                </Accordion.Toggle>

                <Accordion.Collapse eventKey={questionSlug}>
                  <Card.Body className="text-justify">

                    {renderHtml(collapse.body)}
                  </Card.Body>
                </Accordion.Collapse>
              </div>
            </Row>
          );
        })
        : ""}
    </Accordion>
  );
};

export default ExpandableBox;
